export default {
	bg: false,
	content: {
		leftBg: 'https://flourishfiles.blob.core.windows.net/files/Marketing/Website/pennies.png',
		title: "Interested in Joining the Flourish Family?",
		thanksTitle: "Together we can swipe, donate, & give!",
		thankyouParagraph: "We will be in touch in the next 24 hours to discuss next steps.",
	},
}
